import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: "72px",
        backgroundColor: "#00833E",
        marginBottom: "20px",
        paddingLeft: "14%",
        paddingRight: "30px",
        color: "#fff",
        letterSpacing: 0,
    },

    mobile_container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: "56px",
        backgroundColor: "#00833E",
        padding: "0px 20px",
        letterSpacing: 0,
        color: "#fff",
        fontSize: "20px",
        marginTop: "56px",
        width: "100%",
    },

    laptop_container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: "72px",
        backgroundColor: "#00833E",
        marginBottom: "20px",
        paddingLeft: "120px",
        paddingRight: "30px",
        color: "#fff",
        letterSpacing: 0,
        width: "100%",
    },

    leftSide: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "6px",
        marginLeft: "150px",
    },

    rightSide: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "30px",
    },

    imgLabel_container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "5px",
        cursor: "pointer",
    },

    bigFont: {
        fontSize: "28px",
    },
    mediumFont: {
        fontSize: "20px",
        marginTop: "5px",
        fontWeight: "lighter",
    },
    regularFont: {
        fontSize: "16px",
    },
    snackbar_container: {
        left: "45%",
        top: "100px",
        position: "fixed",
        zIndex: 100,
    },
    lightFontWeight: {
        fontWeight: "lighter",
    },
    whiteColor: {
        color: "#fff",
    },

    bottomDrawer_container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        flexDirection: "column",
        padding: "45.5px 20px 31.5px 20px",
        color: "#353535",
        fontSize: "18px",
        letterSpacing: 0,
        gap: "32px",
    },

    bottomDrawer_span: {
        cursor: "pointer",
    },
}));

export default useStyles;
